import React from 'react'

const Dashboard = () => {
  return (
    <>
      <div>
        <h2 className='text-center'>Welcome to Vedic Admin Panel!!!!!!!</h2>
      </div>
    </>
  )
}

export default Dashboard